import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { z } from "zod";
import { MiContentDrawer, MiDetailFields } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { mdiShieldAccountVariant } from "@mdi/js";

const initialData = {
  name: "",
  description: "",
};

export function AddTitleDrawer({ open, onClose, onSubmit, loading, ...rest }) {
  const { classes } = useStyles();

  const titleFields = [
    {
      label: "Title Name",
      name: "name",
      width: "100%",
      validationRule: z
        .string()
        .min(2, "Title name is too short!")
        .max(255, "Title name is too long!"),
    },
    {
      label: "Description",
      name: "description",
      multiline: true,
      width: "100%",
      validationRule: z.string().optional(),
    },
  ];

  const edit = useEdit(initialData, titleFields);

  const handleSubmit = () => onSubmit(edit.getValue());

  useEffect(() => {
    edit.reset();
  }, [open]);

  return (
    <MiContentDrawer
      title="Add Title"
      variant="temporary"
      open={open}
      leftIcon={mdiShieldAccountVariant}
      isLoading={loading}
      onClose={onClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          onClick: handleSubmit,
          disabled: loading || !edit.isValid(),
        },
      ]}
      topRightClose={onClose}
      {...rest}
    >
      <MiDetailFields
        detailFields={titleFields}
        edit={edit}
        containerStyle={classes.container}
      />
    </MiContentDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(3),
    width: "100%",
  },
}));
